import O1HD from "../../../../engines/gameEngine";

const {ccclass, property} = cc._decorator;
/**
 *
 *  键盘Node
 */
@ccclass
export default class InputNode extends cc.Component {

    @property({type:cc.Label,displayName:"标题"})
    lbTitle : cc.Label = null;
    @property({type:cc.Label,displayName:"数字"})
    labelNum : cc.Label = null;
    @property({type:cc.Node,displayName:"键盘Node"})
    keyBoardNode : cc.Node = null;

    private sumMaxString : string = "";

    //完成回调
    mCompleteFun = null;

    onLoad () {}

    start () {
        this.keyBoardNode.y = -1100;
        cc.tween(this.keyBoardNode)
            .to( 0.3,{ y : -510 })
            .start();
    }

    /**
     * 完成回调
     * @param completeFun
     */
    bindData( title: string , completeFun){
        this.mCompleteFun = completeFun;
    }

    /**
     *
     */
    onBtnClick( e , numberStr : string ){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        if ( this.sumMaxString == "0" ) {
            this.sumMaxString = numberStr;
        }else{
            this.sumMaxString += numberStr;
        }
        this._refreshNum();
    }

    /**
     * 删除
     */
    onBtnDelete(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.sumMaxString = this.sumMaxString.substr(0,this.sumMaxString.length-1);
        this._refreshNum();
    }

    /**
     * 确定
     */
    onBtnMakeSure(){
        if ( !this.sumMaxString || this.sumMaxString == "" ) {
            O1HD.getModules().uiControlModule.showMessageBox("请输入金额再提交");
            return;
        }

        if( Number(this.sumMaxString) > O1HD.getServices().userSrv.getCoins() ){
            this.sumMaxString = `${O1HD.getServices().userSrv.getCoins()}`;
            this._refreshNum();
            O1HD.getModules().uiControlModule.showMessageBox("超出您当前拥有的财富值，已变更为您最大的财富值");
            return;
        }

        this.mCompleteFun(Number(this.sumMaxString));
        this._close();
    }

    /**
     * 关闭
     */
    onBtnClose(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this._close();
    }

    private _close(){
        cc.tween(this.keyBoardNode)
            .to( 0.3,{ y : -1100 },{easing:'fade'})
            .call(()=>{
                this.node.removeFromParent();
                this.node.destroy();
            })
            .start();
    }

    //刷新
    private _refreshNum(){
        this.labelNum.string = `${this.sumMaxString}`;
    }

    /**
     * 求和
     * */
    private _sum(array: number[]) {
        let sumValue = 0;
        let rate = 0;
        for ( let itemIndex = array.length - 1 ; itemIndex >= 0 ; itemIndex -- ) {
            sumValue += array[itemIndex] * Math.pow( 10 , rate ++ );
        }
        return sumValue;
    }
}
